import { Sparkles, ArrowRight, GraduationCap } from 'lucide-react';
import { useCounsellingModal } from './CounsellingModal';
import { useNavigate } from 'react-router-dom';

const Hero = () => {
  const { open } = useCounsellingModal();
  const navigate = useNavigate();

  return (
    <section className="ee-hero" data-testid="hero-section">
      <div className="container">
        <div className="ee-hero-content">
          <div className="ee-hero-eyebrow">
            <Sparkles size={14} />
            <span>Premium Education Consultancy</span>
          </div>

          <h1>
            Study in <span className="gold-gradient">Italy, Europe</span>
            <br />
            & MBBS Abroad
          </h1>

          <p className="ee-hero-sub">
            Get admission in top European universities with <strong style={{ color: 'var(--gold)' }}>Zero Tuition Fees</strong>, scholarships up to <strong style={{ color: 'var(--gold)' }}>€11,000/year</strong>, and complete visa support.
          </p>

          <p className="ee-hero-tagline">Guided by a PhD Graduate from the University of Turin, Italy</p>

          <div className="ee-hero-buttons">
            <button
              className="btn-primary"
              onClick={() => open({ source: 'hero' })}
              data-testid="hero-book-btn"
            >
              <GraduationCap size={16} />
              Book Free Counselling
            </button>
            <button
              className="btn-secondary"
              onClick={() => navigate('/universities')}
              data-testid="hero-explore-btn"
            >
              Explore Universities <ArrowRight size={16} />
            </button>
          </div>

          <div className="ee-stats">
            <div className="ee-stat" data-testid="hero-stat-universities">
              <div className="ee-stat-value">25+</div>
              <div className="ee-stat-label">Top Universities</div>
            </div>
            <div className="ee-stat" data-testid="hero-stat-tuition">
              <div className="ee-stat-value">€0</div>
              <div className="ee-stat-label">Tuition Fees</div>
            </div>
            <div className="ee-stat" data-testid="hero-stat-scholarship">
              <div className="ee-stat-value">€11K</div>
              <div className="ee-stat-label">Scholarships</div>
            </div>
            <div className="ee-stat" data-testid="hero-stat-visa">
              <div className="ee-stat-value">95%</div>
              <div className="ee-stat-label">Visa Success</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
